import React from 'react';
import { ContactTemplate } from '../../Templates';
import { connect } from 'react-redux';
import {
  apiGetClientDemands,
  apiSendContact,
  apiSendResponseDemand,
  apiFaqDemandsQuestions
} from '../../Api/Contact/Contact';
import { serilizeGetDemande } from '../../Api/Contact/serilizeContact';
import { DEMANDE_LIMIT, DEMANDE_FROM, DEMANDE_COLOR, FAQ_URL } from '../../Config/Config';
import * as moment from 'moment';
import Store from '../../Redux/Store';
class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFaqSubject: [],
      faqOptions: {},
      faqOptionsKeys: [],
      constactDisableButton: true,
      questionvalue: '',
      resetSelect: 0,
      resetSecondSelect: 0,
      contact: {
        mail: '',
        message: '',
        file: '',
        question: '',
        object:
          this.props.location.state == null
            ? ''
            : this.props.location.state.object
      },
      show: false,
      status:
        this.props.location.state == null
          ? 'Nous contacter'
          : this.props.location.state.status,
      demandeData: [],
      demandeDataMobile: [],
      demandeStep: 1,
      selectedDemande: null,
      page: 1,
      pageNumber: 0,
      windowWidth: window.innerWidth,
      searchWord: '',
      orderBy: '',
      direction: '',
      textUpload: '',
      skip: 0,
      response: '',
      submitContatError: [],
      contractFamily: Store.getState()?.auth?.user?.contractTypes,
    };
  }

  getPageNumber = total => {
    const rest = (total / DEMANDE_LIMIT) % 1 === 0 ? 0 : 1;
    return Math.trunc(total / DEMANDE_LIMIT) + rest;
  };

  sendResponseDesktop = async () => {
    const selectedDemande = this.state.selectedDemande
    const responseToSend = this.state.response
    const newMessage = await this.sendResponse(selectedDemande, responseToSend)

    if (!newMessage.error) {
      this.setState((prev) => {
        const mapFunction = (item) => {
          let newItem = item
          if (item.faqDemandId === selectedDemande.faqDemandId) {
            newItem = Object.assign({}, item)
            newItem.details = newItem.details.concat(newMessage)
          }
          return newItem
        }

        return {
          demandeData: prev.demandeData.map(mapFunction),
          demandeDataMobile: prev.demandeData.map(mapFunction),
          selectedDemande: {
            ...prev.selectedDemande,
            details: prev.selectedDemande.details.concat(newMessage)
          },
          response: ''
        }
      })
    }
  }

  sendResponseMobile = async (selectedDemande, responseToSend, onSuccess) => {
    const newMessage = await this.sendResponse(selectedDemande, responseToSend)

    if (!newMessage.error) {
      this.setState((prev) => {
        const mapFunction = (item) => {
          let newItem = item
          if (item.faqDemandId === selectedDemande.faqDemandId) {
            newItem = Object.assign({}, item)
            newItem.details = newItem.details.concat(newMessage)
          }
          return newItem
        }

        return {
          demandeDataMobile: prev.demandeDataMobile.map(mapFunction),
          demandeData: prev.demandeData.map(mapFunction)
        }
      })
    }

    onSuccess?.()
  }

  sendResponse = async (demandInfos, message) => {
    const selectedDemande = demandInfos
    const responseToSend = message

    const getIndex = (value) => {
      const _value = String(value).toLowerCase()

      if (_value === "client") {
        return 2
      } else if (_value === "spvie") {
        return 0
      } else if (_value === "cgrm") {
        return 1
      }
    }


    const body = JSON.stringify({
      attachmentList: [],
      from: getIndex("client"),
      to: getIndex(selectedDemande.to),
      message: responseToSend,
      created: moment().format("YYYY-MM-DDTHH:mm:ss.SSS")
    })

    try {
      const res = await apiSendResponseDemand(
        selectedDemande.faqDemandId,
        body
      );
      if (res.status === 200) {
        return this.formatMessage({
          attachmentList: [],
          from: "Client",
          to: selectedDemande.to,
          message: responseToSend,
          created: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
        })
      } else {
        return { error: true }
      }
    } catch (e) {
      return { error: true }
    }
  };


  formatMessage = (obj) => {
    return {
      date: moment(obj.created).format("DD-MM-YYYY"),
      description: obj.message || "",
      attachments: obj.attachmentList,
      from: DEMANDE_FROM.find(el => el.key === obj.from) ? DEMANDE_FROM.find(el => el.key === obj.from).from : "###",
    }
  }

  formatDemands = (demand) => {
    let details = []
    details.push(this.formatMessage(demand));
    demand.callBackList?.forEach((item) => details.push(this.formatMessage(item)))

    return {
      from: demand.from,
      to: demand.to,
      faqDemandId: demand.id,
      date: moment(demand.created).format("DD-MM-YYYY"),
      demande: demand.faqType,
      status: DEMANDE_COLOR.find((el) => el.status === demand.status)?.status,
      document: demand.attachmentList?.length || 0,
      details,
    }
  }

  getClientDemand = async (skip, limit, searchWord, orderBy, direction) => {
    const res = await apiGetClientDemands(
      skip,
      limit,
      searchWord,
      orderBy,
      direction
    );
    if (res.status == 200) {
      // modif
      this.setState({
        demandeData: res.data.map((el) => this.formatDemands(el)),
        total: res.total,
        pageNumber: this.getPageNumber(res.total)
      });
    }
  };

  getMobileData = async (skip, limit, data = [], searchWord) => {
    const res = await apiGetClientDemands(skip, limit, searchWord); // modif
    if (res.status == 200) {
      // modif
      this.setState({
        demandeDataMobile: [...data, ...res.data.map((el) => this.formatDemands(el))],
        // demandeDataMobile: [...data, ...serilizeGetDemande(res.data)],
        total: res.total,
        pageNumber: this.getPageNumber(res.total),
        skip: this.state.skip + 1
      });
    }
  };
  groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  getFaqDemandsQuestions = async () => {
    const res = await apiFaqDemandsQuestions(); // modif
    if (res.status == 200) {
      let processedRespKeys = []
      let processedResp = this.groupBy(res.data.map((elem => { return { ...elem, text: elem.object } })), "type")
      for (var key in processedResp) {
        processedRespKeys.push({ text: processedResp[key][0].object, value: key })
      }
      if(Array.isArray(this.state.contractFamily) && !this.state.contractFamily.includes("SANTE")){
        const blackListKey = ["Caisse d’Assurance Maladie", "Bénéficiaires", "Télétransmission_Liaison Noémie"]
        processedRespKeys = processedRespKeys.filter(el => blackListKey.indexOf(el.text)===-1)
      }
      this.setState({ faqOptions: processedResp })
      this.setState({ faqOptionsKeys: processedRespKeys })
    }
  };

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState(() => {
        return {
          windowWidth: window.innerWidth
        };
      });
    });
    this.getClientDemand(
      0,
      DEMANDE_LIMIT,
      this.state.searchWord,
      this.state.orderBy,
      this.state.direction
    );
    this.getMobileData(0, DEMANDE_LIMIT, [], '');
    this.getFaqDemandsQuestions();
    const contactParams = new URLSearchParams(document.location.search)
    if(contactParams.get('subject')=="demandes"){
      this.changeStatus("Mes demandes")
    }
  }

  onSubmit = () => {
    this.sendContact();
  };

  onSelectSubject = (value) => {
    if(value){
      this.setState({ selectedFaqSubject: this.state.faqOptions[value].map((elem) => { return { ...elem, text: elem.question } }) })
    } else {
      this.setState({ selectedFaqSubject: []})
    }
    
    this.setState({
      contact: { ...this.state.contact, type: value, question: "", seletedQuestion: "", mail: '' },
    }, () => {
    })
    this.setState({ resetSelect: this.state.resetSelect + 1 });
   
    
  }
  onChangeContact = (value, key) => {
    this.setState(
      {
        contact: { ...this.state.contact, [key]: value, },
      },
      () => {
        if (this.state.contact) {
          if (this.state.contact.seletedQuestion != "" && this.state.contact.seletedQuestion != null && (this.state.contact.file.length > 0 || this.state.contact.message.trim() != "")) {
            this.setState({ constactDisableButton: false })
          } else {
            this.setState({ constactDisableButton: true })
          }
        }
      }
    );
    if (key == "question") {
      let selectedquestionInSelectedFaqSubjects = this.state.selectedFaqSubject.find((elem) => elem.question == value)
      this.setState(
        {
          contact: { ...this.state.contact, from: selectedquestionInSelectedFaqSubjects.from, to: selectedquestionInSelectedFaqSubjects.to, seletedQuestion: selectedquestionInSelectedFaqSubjects.question, textUpload: selectedquestionInSelectedFaqSubjects.textUpload }
        },
      )
    }

  };

  onHide = () => {
    this.setState({
      show: false
    });
    this.props.history.push({
      pathname: '/contact',
      search: ``
    })
  };

  changeStatus = value => {
    this.setState({
      status: value
    });
    if(value=="Mes demandes"){
      this.props.history.push({
        pathname: '/contact',
        search: `?topCategory=mesdemandes`
      })
    } else {
      this.props.history.push({
        pathname: '/contact',
        search: ``
      })
    }
   
  };

  onClickFAQ = () => {
    // window.location.href = FAQ_URL;
    window.open(FAQ_URL, '_blank');
  };

  sendContact = async () => {
    const body = new FormData();
    body.append('TypeContact', "0");
    body.append('Type', this.state.contact.type);
    body.append('Object', this.state.contact.object);
    body.append('Message', this.state.contact.message);
    body.append('Question', this.state.contact.seletedQuestion);
    body.append('From', this.state.contact.from);
    body.append('To', this.state.contact.to);
    body.append('Attachment', this.state.contact.file[0]);

    const res = await apiSendContact(body);
    if (res.status == 200) {
      this.setState({
        show: true,
        contact: {
          mail: '',
          message: '',
          file: '',
          object: ''
        },
      });
      this.props.history.push({
        pathname: '/contact',
        search: `?category=success`
      })
      this.setState({ submitContatError: [] })
      this.onSelectSubject('')
      this.setState({ resetSecondSelect: this.state.resetSecondSelect + 1 });
    } else {
      if (res.status >= 400) {
        this.setState({ submitContatError: [res.errors[0], ...(res.exceptions ? [res.exceptions[0]] : [])] })
      }
    }
  };

  viewDemandeClicked = (element, index) => {
    this.setState({
      selectedDemande: element,
      demandeStep: 2
    });
  };

  retourClicked = () => {
    this.setState({
      selectedDemande: null,
      demandeStep: 1
    });
  };

  responseClicked = () => {
    return true;
  };

  getSkipLimit = page => {
    return {
      skip: (page - 1) * DEMANDE_LIMIT,
      limit: DEMANDE_LIMIT
    };
  };

  onChangePagination = next => {
    if (next != 0 && next <= this.state.pageNumber) {
      const { skip, limit } = this.getSkipLimit(next);
      this.getClientDemand(
        skip,
        limit,
        this.state.searchWord,
        this.state.orderBy,
        this.state.direction
      );
      this.setState({
        page: next
      });
    }
  };

  scroll = e => {
    const bottom =
      ~~e.target.scrollHeight -
      ~~e.target.scrollTop -
      ~~e.target.clientHeight <=
      1;
    if (
      bottom &&
      this.state.demandeDataMobile.length < this.state.total &&
      this.state.status === 'Mes demandes' &&
      this.state.windowWidth < 768
    ) {
      this.getMobileData(
        this.state.skip * DEMANDE_LIMIT,
        DEMANDE_LIMIT,
        this.state.demandeDataMobile
      );
    }
  };

  onKeyPress = (event, page) => {
    if (event.key === 'Enter') {
      if (page) {
        this.getClientDemand(
          0,
          DEMANDE_LIMIT,
          this.state.searchWord,
          this.state.orderBy,
          this.state.direction
        );
        this.setState({
          page: 1
        });
      } else {
        this.getMobileData(0, DEMANDE_LIMIT, [], this.state.searchWord);
      }
    }
  };

  OnLoopIconClick = (page) => {
    if (page) {
      this.getClientDemand(
        0,
        DEMANDE_LIMIT,
        this.state.searchWord,
        this.state.orderBy,
        this.state.direction
      );
    }
    else {
      this.getMobileData(0, DEMANDE_LIMIT, [], this.state.searchWord);
    }

  }

  searchWordChange = e => {
    this.setState({
      searchWord: e.target.value
    });
  };

  sortClicked = (sort, direction) => {
    this.getClientDemand(
      0,
      DEMANDE_LIMIT,
      this.state.searchWord,
      sort,
      direction
    );
    this.setState({
      orderBy: sort,
      direction: direction,
      page: 1
    });
  };

  responseChanged = e => {
    this.setState({
      response: e.target.value
    });
  };

  render() {
    return (
      <ContactTemplate
        questionvalue={this.state.questionvalue}
        state={this.state}
        onSubmit={this.onSubmit}
        submitError={this.state.submitContatError}
        onClickFAQ={this.onClickFAQ}
        constactDisableButton={this.state.constactDisableButton}
        contact={this.state.contact}
        onChangeContact={this.onChangeContact}
        onHide={() => this.onHide()}
        changeStatus={this.changeStatus}
        demandeData={this.state.demandeData}
        demandeStep={this.state.demandeStep}
        viewDemandeClicked={this.viewDemandeClicked}
        selectedDemande={this.state.selectedDemande}
        responseClicked={this.responseClicked}
        retourClicked={this.retourClicked}
        page={this.state.page}
        pageNumber={this.state.pageNumber}
        onChangePagination={this.onChangePagination}
        onScroll={this.scroll}
        demandeDataMobile={this.state.demandeDataMobile}
        value={this.state.searchWord}
        onKeyPress={this.onKeyPress}
        OnLoopIconClick={this.OnLoopIconClick}
        onChange={this.searchWordChange}
        sortClicked={this.sortClicked}
        response={this.state.response}
        responseChanged={this.responseChanged}
        sendResponse={this.sendResponseDesktop}
        sendResponseMobile={this.sendResponseMobile}
        faqOptions={this.state.faqOptions}
        faqOptionsKeys={this.state.faqOptionsKeys}
        onSelectSubject={this.onSelectSubject}
        selectedFaqSubject={this.state.selectedFaqSubject}
        reset={this.state.resetSelect}
        resetSecond={this.state.resetSecondSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
});
const mapDispatchToProps = dispatch => {
  return {
    dispatch: action => {
      dispatch(action);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Contact);
